// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Dropdown from "../../html/Dropdown.js";
import * as Buhta_cabinet__IconSidebarSvgTickets from "./Icons/IconSidebarSvgTickets.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__NavLink from "../../html/NavLink.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import LogoSvg from "static/icons/logo.svg";

function AdminSidebar$ProfileDropdown(Props) {
  const match = React.useState(function () {
        return false;
      });
  const setIsDropdownShown = match[1];
  const match$1 = React.useState(function () {
        return false;
      });
  const setIsProfileHovered = match$1[1];
  const isProfileHovered = match$1[0];
  const match$2 = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match$2[0];
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const currentUrlStr = Buhta_cabinet__Route.toString(currentRoute);
  let userpic;
  let exit = 0;
  if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
    exit = 1;
  } else {
    const identityProfile = identity._0;
    userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
            children: identityProfile.first_name.substring(0, 1),
            className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
          }) : JsxRuntime.jsx("img", {
            className: "w-5 h-5 rounded-50pct",
            src: identityProfile.userpic_url
          });
  }
  if (exit === 1) {
    userpic = JsxRuntime.jsx("img", {
          className: "w-5 h-5 rounded-50pct",
          src: StaticAsset.src("/static/icons/profile-photo.png")
        });
  }
  let fullName;
  if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
    fullName = "Профиль";
  } else {
    const identityProfile$1 = identity._0;
    fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
  }
  const activator = function (param) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        userpic,
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: Cn.fromList({
                                    hd: "truncate ml-4",
                                    tl: {
                                      hd: isProfileHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                                      tl: /* [] */0
                                    }
                                  }),
                              children: fullName
                            })
                      ],
                      className: Cn.fromList({
                            hd: "whitespace-nowrap px-6 flex py-1.5 hover:w-full",
                            tl: {
                              hd: isProfileHovered ? "bg-white/8" : "hover:bg-white/8",
                              tl: /* [] */0
                            }
                          }),
                      onMouseEnter: (function (param) {
                          Curry._1(setIsProfileHovered, (function (param) {
                                  return true;
                                }));
                        }),
                      onMouseLeave: (function (param) {
                          Curry._1(setIsProfileHovered, (function (param) {
                                  return false;
                                }));
                        })
                    }),
                className: "pb-6"
              });
  };
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
              align: "TopCenter",
              activator: activator,
              background: "bg-white",
              isDropdownShown: match[0],
              setIsDropdownShown: setIsDropdownShown,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                            route: /* OrgChoose */0,
                            className: "p-2 hover:bg-gray-pale block",
                            onLinkClicked: (function (param) {
                                Curry._1(setIsDropdownShown, (function (param) {
                                        return false;
                                      }));
                              }),
                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  children: "Кабинет"
                                })
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                            route: {
                              TAG: /* Profile */5,
                              _0: /* General */0
                            },
                            className: "p-2 hover:bg-gray-pale block",
                            onLinkClicked: (function (param) {
                                Curry._1(setIsDropdownShown, (function (param) {
                                        return false;
                                      }));
                              }),
                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  children: "Настройки профиля"
                                }),
                            urlParams: {
                              hd: [
                                "return_to",
                                currentUrlStr
                              ],
                              tl: /* [] */0
                            }
                          }),
                      JsxRuntime.jsx("hr", {
                            className: "my-1"
                          }),
                      JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-alert",
                                    children: "Выйти из аккаунта"
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/logout-red-20.svg")
                                  })
                            ],
                            className: "flex p-2 hover:bg-gray-pale justify-between w-full",
                            onClick: (function (param) {
                                window.location.href = "/logout";
                              })
                          })
                    ],
                    className: "bg-white w-60 p-2 shadow-kkms rounded"
                  })
            });
}

const ProfileDropdown = {
  make: AdminSidebar$ProfileDropdown
};

const sidebar = Cn.fromList({
      hd: "shrink-0 flex flex-col border-r border-white-8% transition-all duration-500 ease-in",
      tl: {
        hd: "w-61",
        tl: /* [] */0
      }
    });

const header = "flex justify-between h-12 p-6 pt-0";

function headerItem(firstCollapse) {
  return Cn.fromList({
              hd: "cursor-pointer",
              tl: {
                hd: Cn.on("animate-fadeScaleIn", !firstCollapse),
                tl: /* [] */0
              }
            });
}

const content = "w-full h-full py-6";

const itemWrapper = "last:mt-auto";

function item(active) {
  return Cn.fromList({
              hd: "flex py-1.5 px-6 items-center hover:bg-white-8%",
              tl: {
                hd: Cn.on("bg-white-8% text-white", active),
                tl: {
                  hd: Cn.on("bg-transparent text-asphalt", !active),
                  tl: /* [] */0
                }
              }
            });
}

const Styles = {
  sidebar: sidebar,
  header: header,
  headerItem: headerItem,
  content: content,
  itemWrapper: itemWrapper,
  item: item,
  openBtn: "p-6 pt-0"
};

function make(item$1) {
  return function (className) {
    return function (onCloseOpt) {
      const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
            
          });
      const isActiveRoute = item$1.isActiveRoute;
      const route = item$1.route;
      const label = item$1.label;
      const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
      const deviceType = state.deviceType;
      const match = React.useState(function () {
            return "main";
          });
      const setBar = match[1];
      const bar = match[0];
      const match$1 = React.useState(function () {
            return false;
          });
      const setIsHovered = match$1[1];
      const isHovered = match$1[0];
      const className$1 = Cn.fromList({
            hd: itemWrapper,
            tl: {
              hd: Cn.take(className),
              tl: /* [] */0
            }
          });
      const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
      const adminRoute = {
        TAG: /* Admin */7,
        _0: route
      };
      const isActive = isActiveRoute !== undefined ? Curry._1(isActiveRoute, currentRoute) : false;
      let icon;
      if (typeof route === "number") {
        icon = JsxRuntime.jsx("img", {
              className: "h-5 w-5",
              src: isHovered || isActive ? StaticAsset.src("/static/icons/home-white-20.svg") : StaticAsset.src("/static/icons/home.svg")
            });
      } else {
        switch (route.TAG | 0) {
          case /* Keychain */0 :
              icon = JsxRuntime.jsx("img", {
                    className: "h-5 w-5",
                    src: isHovered || isActive ? StaticAsset.src("/static/icons/key-white-20.svg") : StaticAsset.src("/static/icons/key-gray-20.svg")
                  });
              break;
          case /* Orgs */1 :
              icon = JsxRuntime.jsx("img", {
                    className: "h-5 w-5",
                    src: isHovered || isActive ? StaticAsset.src("/static/icons/enterprise-white-20.svg") : StaticAsset.src("/static/icons/enterprise-gray-20.svg")
                  });
              break;
          case /* Identities */2 :
              icon = JsxRuntime.jsx("img", {
                    className: "h-5 w-5",
                    src: isHovered || isActive ? StaticAsset.src("/static/icons/user-white-20.svg") : StaticAsset.src("/static/icons/user-gray-20.svg")
                  });
              break;
          case /* Help */3 :
              icon = JsxRuntime.jsx(Buhta_cabinet__IconSidebarSvgTickets.make, {});
              break;
          
        }
      }
      let tmp;
      if (deviceType === "mobile") {
        let tmp$1 = {
          route: adminRoute,
          currentRoute: currentRoute,
          className: "flex py-1.5 items-center sm:bg-white/8 sidebar__item active__item",
          activeClassName: "flex py-1.5 items-center hover:bg-white/8 sidebar__item sm:bg-white/8 text-white active__item",
          children: [
            JsxRuntime.jsx("div", {
                  children: icon,
                  className: "sidebar__item__icon"
                }),
            JsxRuntime.jsx("span", {
                  children: label,
                  className: Cn.fromList({
                        hd: "ml-4",
                        tl: /* [] */0
                      })
                })
          ],
          onClose: onClose,
          bar: bar,
          setBar: setBar,
          onMouseEnter: (function (param) {
              Curry._1(setIsHovered, (function (param) {
                      return true;
                    }));
            }),
          onMouseLeave: (function (param) {
              Curry._1(setIsHovered, (function (param) {
                      return false;
                    }));
            })
        };
        if (isActiveRoute !== undefined) {
          tmp$1.isActiveRoute = Caml_option.valFromOption(isActiveRoute);
        }
        tmp = JsxRuntime.jsx(Buhta_components__Text.P.make, {
              className: "last:mt-auto text-gray-medium",
              children: JsxRuntime.jsxs(Buhta_cabinet__NavLink.make, tmp$1)
            });
      } else {
        let tmp$2 = {
          route: adminRoute,
          currentRoute: currentRoute,
          className: "flex py-1.5 px-6 items-center hover:bg-white/8 sidebar__item",
          activeClassName: item(true),
          children: [
            JsxRuntime.jsx("div", {
                  children: icon,
                  className: "sidebar__item__icon"
                }),
            JsxRuntime.jsx("span", {
                  children: label,
                  className: Cn.fromList({
                        hd: "ml-4",
                        tl: /* [] */0
                      })
                })
          ],
          onClose: onClose,
          bar: bar,
          setBar: setBar,
          onMouseEnter: (function (param) {
              Curry._1(setIsHovered, (function (param) {
                      return true;
                    }));
            }),
          onMouseLeave: (function (param) {
              Curry._1(setIsHovered, (function (param) {
                      return false;
                    }));
            })
        };
        if (isActiveRoute !== undefined) {
          tmp$2.isActiveRoute = Caml_option.valFromOption(isActiveRoute);
        }
        tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                    hd: className$1,
                    tl: {
                      hd: "text-gray-medium",
                      tl: /* [] */0
                    }
                  }),
              children: JsxRuntime.jsxs(Buhta_cabinet__NavLink.make, tmp$2)
            });
      }
      return JsxRuntime.jsx("div", {
                  children: tmp
                });
    };
  };
}

function AdminSidebar$SidebarContent$Item(Props) {
  return Curry._1(make(Props.item)(Props.className), Props.onClose);
}

const Item = {
  make: AdminSidebar$SidebarContent$Item
};

function AdminSidebar$SidebarContent(Props) {
  let className = Props.className;
  const className$1 = Cn.fromList({
        hd: sidebar,
        tl: {
          hd: Cn.take(className),
          tl: /* [] */0
        }
      });
  const match = React.useState(function () {
        return true;
      });
  const sidebarItems_0 = {
    label: "Главная",
    route: /* Main */0,
    isActiveRoute: (function (param) {
        if (typeof param === "number" || !(param.TAG === /* Admin */7 && typeof param._0 === "number")) {
          return false;
        } else {
          return true;
        }
      })
  };
  const sidebarItems_1 = {
    hd: {
      label: "Предприятия",
      route: {
        TAG: /* Orgs */1,
        _0: /* List */0
      },
      isActiveRoute: (function (param) {
          if (typeof param === "number") {
            return false;
          }
          if (param.TAG !== /* Admin */7) {
            return false;
          }
          let tmp = param._0;
          if (typeof tmp === "number" || tmp.TAG !== /* Orgs */1) {
            return false;
          } else {
            return true;
          }
        })
    },
    tl: {
      hd: {
        label: "Пользователи",
        route: {
          TAG: /* Identities */2,
          _0: /* List */0
        },
        isActiveRoute: (function (param) {
            if (typeof param === "number") {
              return false;
            }
            if (param.TAG !== /* Admin */7) {
              return false;
            }
            let tmp = param._0;
            if (typeof tmp === "number" || tmp.TAG !== /* Identities */2) {
              return false;
            } else {
              return true;
            }
          })
      },
      tl: {
        hd: {
          label: "Ключи",
          route: {
            TAG: /* Keychain */0,
            _0: {
              TAG: /* Keys */0,
              _0: /* List */0
            }
          },
          isActiveRoute: (function (param) {
              if (typeof param === "number") {
                return false;
              }
              if (param.TAG !== /* Admin */7) {
                return false;
              }
              let tmp = param._0;
              if (typeof tmp === "number" || tmp.TAG !== /* Keychain */0) {
                return false;
              } else {
                return true;
              }
            })
        },
        tl: /* [] */0
      }
    }
  };
  const sidebarItems = {
    hd: sidebarItems_0,
    tl: sidebarItems_1
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: {
                                    TAG: /* Admin */7,
                                    _0: /* Main */0
                                  },
                                  children: JsxRuntime.jsx(LogoSvg, {
                                        alt: "logo",
                                        className: headerItem(match[0])
                                      })
                                }),
                            className: header
                          }),
                      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(sidebarItems, (function (index, item) {
                                  const Key = "sidebar__item_" + String(index);
                                  return JsxRuntime.jsx(AdminSidebar$SidebarContent$Item, {
                                              item: item
                                            }, Key);
                                })))
                    ],
                    className: content
                  }),
              className: className$1
            });
}

const SidebarContent = {
  Styles: Styles,
  Item: Item,
  make: AdminSidebar$SidebarContent
};

function AdminSidebar(Props) {
  const sidebarRef = React.useRef(null);
  const overlayRef = React.useRef(null);
  const sidebarContentRef = React.useRef(null);
  React.useEffect((function () {
          const sidebarContentRef$1 = sidebarContentRef.current;
          const sidebarEl = sidebarRef.current;
          const overlayEl = overlayRef.current;
          if (!(sidebarEl == null) && !(overlayEl == null) && !(sidebarContentRef$1 == null)) {
            sidebarContentRef$1.classList.remove("animate-slideOut");
            sidebarContentRef$1.classList.add("animate-slideIn");
            overlayEl.classList.remove("hidden");
            sidebarEl.classList.remove("hidden");
          }
          
        }), []);
  return JsxRuntime.jsxs("div", {
              ref: sidebarRef,
              children: [
                JsxRuntime.jsx("div", {
                      ref: sidebarRef,
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    ref: sidebarContentRef,
                                    children: JsxRuntime.jsx(AdminSidebar$SidebarContent, {}),
                                    className: Cn.fromList({
                                          hd: "relative flex-1 flex transition ease-in-out duration-300",
                                          tl: /* [] */0
                                        })
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "shrink-0 w-14"
                                  })
                            ],
                            className: "fixed inset-y-0 left-0 flex z-40"
                          }),
                      className: Cn.fromList({
                            hd: "sm:hidden",
                            tl: /* [] */0
                          })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(AdminSidebar$SidebarContent, {}),
                        JsxRuntime.jsx(AdminSidebar$ProfileDropdown, {})
                      ],
                      className: "bg-black hidden h-full sm:flex sm:shrink-0 flex-col justify-between"
                    })
              ]
            });
}

const make$1 = AdminSidebar;

export {
  ProfileDropdown ,
  SidebarContent ,
  make$1 as make,
}
/* sidebar Not a pure module */
